import {
  IconFilter,
  Button,
  AddFilterButton,
  type EntityBarFilterConfig
} from '@sequencehq/core-components'

interface WatchtowerFilterButtonProps<T extends string> {
  filterConfigs: EntityBarFilterConfig<T>[]
  selectedFilters: Record<T, string[]>
  hasActiveFilters: boolean
  onFilterChange: (filterType: T, selectedIds: string[]) => void
}

export const WatchtowerFilterButton = <T extends string>({
  filterConfigs,
  selectedFilters,
  hasActiveFilters,
  onFilterChange
}: WatchtowerFilterButtonProps<T>) => {
  return (
    <AddFilterButton
      filterConfigs={filterConfigs}
      selectedFilters={selectedFilters}
      hasActiveFilters={hasActiveFilters}
      onFilterChange={onFilterChange}
      showIconsInMenu={false}
      renderButton={({ disabled }) => {
        return (
          <Button
            variant="secondary"
            disabled={disabled}
            icon={<IconFilter color="inherit" />}
            aria-label="filters"
          />
        )
      }}
    />
  )
}
